import React from "react";
import "./BigMenuList.css";
import { Link } from "react-router-dom";

class BigMenuList extends React.Component {
    constructor(props) {
        super(props);
        let data = { boxes: [], ...props.data };
        this.state = {
            data: data,
            config: { config: [], ...props.config },
            width: 0,
            height: 0
        };
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }
    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };
    render() {
        if (this.state.width > 767) {
            let bigMenuListBoxes = this.state.data.boxes.map(
                (bigMenuListBox, index) => {
                    return (

                        <div
                            key={index}
                            className="col-sm-4 single-box"
                            style={{
                                backgroundImage: `url(${bigMenuListBox.image})`
                            }}

                        >
                            <Link to={bigMenuListBox.url} target={bigMenuListBox.url_external ? "_self" : ""}>
                                <div className="single-box--inner" />

                                <div className="BigMenuList-content">
                                    <h2 className="BigMenuList-title">{bigMenuListBox.name}</h2>
                                    <ul className="BigMenuListItems">
                                        {bigMenuListBox.submenu
                                            ? bigMenuListBox.submenu.map((elem, a) => {
                                                return (
                                                    <li className="BigMenuList-link" key={a}>
                                                        <Link to={elem.url}>{elem.name}</Link>
                                                    </li>
                                                );
                                            })
                                            : ""}
                                    </ul>
                                </div>
                            </Link>
                        </div>

                    );
                }
            );
            //console.log(this.state.width);
            return <div className="BigMenuList">{bigMenuListBoxes}</div>;
        } else {
            let backGroundSmallImage = this.state.data.boxes[0].image;

            let bigMenuListBoxes = this.state.data.boxes.map(
                (bigMenuListBox, index) => {
                    return (
                        <div className="BigMenuList__small-wrapper" key={index}>
                            <h2 className="BigMenuList-title">{bigMenuListBox.name}</h2>
                            <ul className="BigMenuListItems">
                                {bigMenuListBox.submenu
                                    ? bigMenuListBox.submenu.map((bigMenuListBox, a) => {
                                        return (
                                            <li className="BigMenuList-link" key={a}>
                                                <Link to={bigMenuListBox.url}>
                                                    {bigMenuListBox.name}
                                                </Link>
                                            </li>
                                        );
                                    })
                                    : null}
                            </ul>
                        </div>
                    );
                }
            );
            return (
                <div
                    className="BigMenuList__container--small"
                    style={{
                        backgroundImage: `url(${backGroundSmallImage})`
                    }}
                >
                    <div className="single-box--inner" />
                    <div>{bigMenuListBoxes}</div>
                </div>
            );
        }
    }
}
export default BigMenuList;



// WEBPACK FOOTER //
// ./src/Components/Elements/BigMenuList/BigMenuList.js